define('plugin/invoice/view/InvoicePaymentSystemFreeView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Invoice payment system view
     *
     * @class InvoicePaymentSystemFreeView
     */
    return LayoutView.extend({

        template: '#invoice_payment_system_free_view',
        ui: {
            'btn': '#sb_pay_btn'
        },
        triggers: {
            'click @ui.btn': 'payment_processor:pay:free'
        }

    });

});
